module.exports = __webpack_public_path__ + "img/analytics.7fb224c8.webp";